import React from "react";
import TextButton from "../../../templates/component/buttons/textButton";

const TestimonialAddButton = () =>{

    return(
        <>
            <TextButton />

        </>
    )
}

export default TestimonialAddButton;